import React, { useContext } from 'react';
import Style from './commands.tailwind';
import { useProjectContext, Button, ViewContext, useNavigate } from 'components/lib';
import { useTranslate } from 'app/translations';
import { AuthContext } from 'app/auth';
import { useQueryClient } from 'react-query';

const TicketCommands = ({ ticket }) => {
    const viewContext = useContext(ViewContext);
    const navigate = useNavigate();
    const { _t } = useTranslate();
    const { projectUser } = useProjectContext();
    const url = ticket.integration_data?.url;
    const queryClient = useQueryClient();

    const {
        user: { permission, user_id },
    } = useContext(AuthContext);

    const canArchive =
        ticket?.user_id === user_id ||
        projectUser?.role === 'owner' ||
        projectUser?.role === 'admin';

    const onArchive = () => {
        viewContext.modal.show(
            {
                title: _t('ticket.archive.title'),
                form: {},
                buttonText: _t('archive'),
                url: '/api/ticket/' + ticket.id + '/archive',
                method: 'PUT',
                destructive: true,
                text: _t('ticket.archive.description'),
            },
            () => {
                queryClient.refetchQueries('tickets');
                viewContext.modal.hide();
                navigate('/app/tickets');
            },
        );
    };

    if (!url && !canArchive) return null;

    return (
        <div className={Style.container}>
            {url && permission !== 'contact' && (
                <Button
                    text={
                        _t('view.on') +
                        ' ' +
                        (ticket.ticket_category?.integration_data?.service || '')
                    }
                    variant="secondary"
                    size="sm"
                    className={Style.btn}
                    icon="external-link"
                    iconColor="currentColor"
                    action={() => window.open(url, '_blank')}
                />
            )}
            {canArchive && (
                <Button
                    text={_t('archive')}
                    variant="ghost"
                    size="sm"
                    className={Style.archive}
                    action={onArchive}
                />
            )}
        </div>
    );
};

export default TicketCommands;
